import { useQuery } from "@tanstack/react-query";
import {
  StudyICFSelectAllParams,
  volunteerStudyICFInfo,
} from "modules/Volunteer/AssigningStudyModule/StudyICF/api/volunteerStudyICFInfo.api";
import { GetUserData } from "common/service/CommonService";
import { volunteerICFInfo } from "./volunteerICF";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

// ------------------------------------------------------------------
//-- Volunteer
// ------------------------------------------------------------------

export const useVolunteerICF = ({
  volunteerid,
}: StudyICFSelectAllParams = {}) => {
  const Select = useQuery({
    queryKey: [
      "volunteer-rcf-select",
      {
        volunteerid,
      },
    ],
    queryFn: () => volunteerICFInfo.getSelectData(volunteerid!),
    enabled: !!volunteerid,
  });

  return {
    Select,
  };
};
